<template>
    <div class="text-white flex flex-col my-4" v-if="race">
        <span class="grid grid-cols-2 col-span-1 mb-2">
            <span>{{ moment(race.starts_at).format('k:mm') }} <strong>{{ meeting.name }}</strong></span>
            <span class="flex justify-end">{{ race.runner_count }} Runners</span>
        </span>

        <span class="mb-2 text-gray-300 text-xs">{{ race.title }}</span>

        <span class="text-gray-200 text-xs">Class: <strong>{{ race.class }}</strong> Distance: <strong>{{ yardsToMilesAndFurlongs(race.distance) }}</strong></span>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        props: {
            meeting: {
                type: Object,
                default: {}
            },
            race: {
                type: Object,
                default: {}
            }
        },

        setup(props) {
            const yardsToMilesAndFurlongs = (yards) => {
                let furlongToYard = 220;
                let mileToYard = 1760;

                let miles = Math.floor(yards / mileToYard)
                yards = yards % mileToYard

                let furlongs = Math.floor(yards / furlongToYard)
                yards = yards % furlongToYard

                return `${miles > 0 ? miles + 'm' : ''} ${furlongs > 0 ? furlongs + 'f' : ''} ${yards > 0 ? yards + 'y' : ''}`
            }

            return {
                moment,
                yardsToMilesAndFurlongs,
            }
        }
    }
</script>
